import React, { FC } from 'react';

import { ProfileList, Queries, IEmptyState } from 'components';
import { SearchPeopleDocument } from 'api';

interface IProps {
  emptyStateName?: keyof IEmptyState;
  variables: object;
}

const QueryList: FC<IProps> = ({ emptyStateName, variables }) => (
  <Queries.Search document={SearchPeopleDocument} variables={variables}>
    {({ loading, exhausted, results, onLoadMore }) => (
      <ProfileList
        emptyStateName={emptyStateName}
        loading={loading}
        profiles={results}
        disableLoadMore={exhausted}
        onLoadMore={onLoadMore}
      />
    )}
  </Queries.Search>
);

export default QueryList;
